import { fromJS } from 'immutable';

// Add Folder Dialog
const initialState = fromJS({
  open: false,
});


export default function freeContractDialog(state = initialState, { type, payload }) {
  switch (type) {
    case 'SHOW_FREE_CONTRACT_DIALOG':
      return state
              .set('open', true)
              .set('url', payload.url)
              .set('contractId', payload.contractId)
              .set('freeContractsLeft', payload.freeContractsLeft);
    case 'CLOSE_FREE_CONTRACT_DIALOG':
    case 'USED_AS_FREE_BY_CONTRACTOR':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/free-contract-for-contractor-dialog.js